import { render } from "./UserRides.vue?vue&type=template&id=34c0d18e"
import script from "./UserRides.vue?vue&type=script&lang=js"
export * from "./UserRides.vue?vue&type=script&lang=js"
script.render = render

export default script